import type { PayoutMethod } from '@chukua/common';

export const PAYOUT_METHOD_LABELS: Record<PayoutMethod, string> = {
  mpesa: 'M-Pesa',
  bank: 'Bank',
};
